export default {
  en: {
    close: 'Close',
    blog: 'Blog',
    github: 'GitHub',
    codeberg: 'Codeberg',
    builtWith: 'Built with Dagaz',
    allRightsReserved: 'All rights reserved',
    viewBlog: 'View Blog',
    selectLanguage: 'Select language',
    mainSubtitle: 'A modern, serverless blog starter built with SvelteKit & Cloudflare',
    keyFeatures: 'Key Features',
    builtWithModernTech: 'Built With Modern Tech',
    blogComingSoon: 'Blog Coming Soon',
    noPostsFound: 'No blog posts found.',
    checkBackLater: 'Check back for new content and updates.',
    refresh: 'Refresh',
    readArticle: 'Read Article',
    articles: 'Articles',
    blogDescription: 'Insights and tutorials on modern web development',
    loadingArticles: 'Loading articles...',
    categories: 'Categories',
    tags: 'Tags',
    resetFilters: 'Reset Filters',
    noMatchingPosts: 'No posts match your current filter criteria.',
    showAllPosts: 'Show All Posts',
    loadingPost: 'Loading post...',
    minRead: 'min read',
    backToPosts: 'Back to posts',
    postNotFound: 'Post Not Found',
    postNotFoundDesc: "Sorry, the post you're looking for couldn't be loaded.",
    returnToBlog: 'Return to blog',
    home: 'Home',
    copyright: '© {year}',
    pageTitle: 'Dagaz - Modern Serverless Blog Starter',

    // Feature names
    trulyServerless: 'Truly Serverless',
    markdownBlog: 'Markdown Blog',
    darkLightTheme: 'Dark/Light Theme',
    localization: 'Localization',

    // Feature descriptions
    trulyServerlessDesc: 'Zero server management with global CDN delivery',
    markdownBlogDesc: 'Write content in easy-to-use markdown format',
    darkLightThemeDesc: 'Built-in theme switching with system detection',
    localizationDesc: 'Easy multi-language support built in',

    // Detailed feature descriptions (added)
    featureDescServerless:
      'Deploy globally with zero server management. Enjoy automatic scaling, high availability, and lightning-fast CDN delivery.',
    featureDescMarkdown:
      'Author content in intuitive Markdown with full Svelte component support. Create interactive posts that stand out from standard blogs.',
    featureDescTheme:
      'Polished theme system with automatic OS preference detection. Customize colors to match your brand with minimal effort.',
    featureDescLocalization:
      'Reach global audiences with built-in multi-language support. Add new languages without changing your codebase structure.',

    // Tech stack
    svelteKit: 'SvelteKit 2.x',
    tailwind: 'Tailwind 4',
    cloudflare: 'Cloudflare',
    pnpm: 'PNPM',

    // Theme
    switchToLightMode: 'Switch to light mode',
    switchToDarkMode: 'Switch to dark mode',

    // Contact page
    contact: 'Contact',
    contactSubtitle: "Let's start a conversation about your project",
    contactName: 'Name',
    contactEmail: 'Email',
    contactMessage: 'Message',
    contactNamePlaceholder: 'Your name',
    contactEmailPlaceholder: 'your.email@example.com',
    contactMessagePlaceholder: 'Tell me about your project...',
    contactSending: 'Sending...',
    contactSend: 'Send Message',
    contactSendAnother: 'Send Another Message',
    contactSuccess: 'Message Sent',
    contactOtherWays: 'Other Ways to Connect',
    contactNameError: 'Please enter your name (at least 2 characters)',
    contactEmailError: 'Please enter a valid email address',
    contactMessageError: 'Please enter a message (at least 10 characters)',
    contactFormSubmitting: 'Submitting...',
    contactFormSuccess: "Your message has been sent successfully. We'll get back to you soon!",
    contactFormError: 'There was an error sending your message. Please try again later.',

    // Manifesto page
    manifesto: 'Manifesto',
    manifestoTitle: 'The Dagaz Manifesto',
    manifestoDescription:
      'The philosophy and motivation behind the Dagaz SvelteKit starter project',
    whyCreated: 'Why I Created Dagaz',
    corePrinciples: 'Core Principles',
    miozuBundle: 'The Miozu Bundle',
    lookingForward: 'Looking Forward',
    minimalDependencies: 'Minimal Dependencies',
    functionalApproach: 'Functional Approach',
    modularArchitecture: 'Modular Architecture',
    nativeFirst: 'Native First',

    // Home page
    whyChooseDagaz: 'Why Choose Dagaz?',
    gettingStartedSimple: 'Getting Started is Simple',
    readyToGoMinute: 'Ready to go in under a minute. No configuration needed.',
    cloneRepository: 'Clone Repository',
    startBuildingToday: 'Start Building Your Project Today',
    joinCommunity: 'Join the growing community of developers using Dagaz for their projects.',
    viewOnGitHub: 'View on GitHub',
    readDocumentation: 'Read Documentation',
    homePageTitle: 'Dagaz - Minimal SvelteKit Starter for Landing Pages',
    homePageDescription:
      'A modern, minimal SvelteKit starter with just 2 dependencies. Perfect for business landing pages and content-focused sites.',

    // Blog related translations
    tableOfContents: 'Table of Contents',
    share: 'Share',
    copied: 'Copied!',
    copyLink: 'Copy Link',
    previous: 'Previous',
    next: 'Next',
    continueReading: 'Continue Reading',
    topics: 'Topics',
    subscribeNewsletter: 'Subscribe to our newsletter',
    newsletterDesc: 'Get the latest posts delivered right to your inbox',
    newsletterPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    newsletterDisclaimer: 'We respect your privacy. Unsubscribe at any time.',
    backToTop: 'Back to top'
  },

  // French translations
  fr: {
    close: 'Fermer',
    blog: 'Blog',
    github: 'GitHub',
    codeberg: 'Codeberg',
    builtWith: 'Créé avec Dagaz',
    allRightsReserved: 'Tous droits réservés',
    viewBlog: 'Voir le Blog',
    selectLanguage: 'Choisir la langue',
    mainSubtitle: 'Un blog moderne et sans serveur créé avec SvelteKit et Cloudflare',
    keyFeatures: 'Fonctionnalités Clés',
    builtWithModernTech: 'Construit Avec Des Technologies Modernes',
    blogComingSoon: 'Blog Bientôt Disponible',
    noPostsFound: 'Aucun article de blog trouvé.',
    checkBackLater: 'Revenez plus tard pour de nouveaux contenus et mises à jour.',
    refresh: 'Actualiser',
    readArticle: "Lire l'Article",
    articles: 'Articles',
    blogDescription: 'Idées et tutoriels sur le développement web moderne',
    loadingArticles: 'Chargement des articles...',
    categories: 'Catégories',
    tags: 'Tags',
    resetFilters: 'Réinitialiser les Filtres',
    noMatchingPosts: 'Aucun article ne correspond à vos critères de filtre actuels.',
    showAllPosts: 'Afficher Tous les Articles',
    loadingPost: "Chargement de l'article...",
    minRead: 'min de lecture',
    backToPosts: 'Retour aux articles',
    postNotFound: 'Article Non Trouvé',
    postNotFoundDesc: "Désolé, l'article que vous recherchez n'a pas pu être chargé.",
    returnToBlog: 'Retourner au blog',
    home: 'Accueil',
    copyright: '© {year}',
    pageTitle: 'Dagaz - Starter de Blog Sans Serveur Moderne',

    // Feature names
    trulyServerless: 'Vraiment Sans Serveur',
    markdownBlog: 'Blog en Markdown',
    darkLightTheme: 'Thème Clair/Sombre',
    localization: 'Localisation',

    // Feature descriptions
    trulyServerlessDesc: 'Zéro gestion de serveur avec livraison CDN mondiale',
    markdownBlogDesc: 'Rédigez du contenu dans un format markdown facile à utiliser',
    darkLightThemeDesc: 'Changement de thème intégré avec détection du système',
    localizationDesc: 'Support multilingue facile intégré',

    // Detailed feature descriptions (added)
    featureDescServerless:
      "Déployez globalement sans gestion de serveur. Profitez de la mise à l'échelle automatique, de la haute disponibilité et de la livraison CDN ultra-rapide.",
    featureDescMarkdown:
      'Créez du contenu en Markdown intuitif avec prise en charge complète des composants Svelte. Créez des articles interactifs qui se démarquent des blogs standard.',
    featureDescTheme:
      "Système de thème raffiné avec détection automatique des préférences du système. Personnalisez les couleurs pour correspondre à votre marque avec un minimum d'effort.",
    featureDescLocalization:
      'Atteignez des audiences mondiales grâce à la prise en charge multilingue intégrée. Ajoutez de nouvelles langues sans modifier la structure de votre code.',

    // Tech stack
    svelteKit: 'SvelteKit 2.x',
    tailwind: 'Tailwind 4',
    cloudflare: 'Cloudflare',
    pnpm: 'PNPM',

    // Theme
    switchToLightMode: 'Passer au mode clair',
    switchToDarkMode: 'Passer au mode sombre',

    // Contact page
    contact: 'Contact',
    contactSubtitle: 'Commençons une conversation sur votre projet',
    contactName: 'Nom',
    contactEmail: 'Email',
    contactMessage: 'Message',
    contactNamePlaceholder: 'Votre nom',
    contactEmailPlaceholder: 'votre.email@exemple.com',
    contactMessagePlaceholder: 'Parlez-moi de votre projet...',
    contactSending: 'Envoi en cours...',
    contactSend: 'Envoyer le Message',
    contactSendAnother: 'Envoyer un Autre Message',
    contactSuccess: 'Message Envoyé',
    contactOtherWays: 'Autres Façons de se Connecter',
    contactNameError: 'Veuillez entrer votre nom (au moins 2 caractères)',
    contactEmailError: 'Veuillez entrer une adresse email valide',
    contactMessageError: 'Veuillez entrer un message (au moins 10 caractères)',
    contactFormSubmitting: 'Envoi en cours...',
    contactFormSuccess: 'Votre message a été envoyé avec succès. Nous vous répondrons bientôt !',
    contactFormError:
      "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer plus tard.",

    contact: 'Contact',

    // Make sure other translations exist:
    close: 'Fermer',
    blog: 'Blog',
    github: 'GitHub',
    codeberg: 'Codeberg',
    builtWith: 'Créé avec Dagaz',
    allRightsReserved: 'Tous droits réservés',

    // Manifesto page
    manifesto: 'Manifeste',
    manifestoTitle: 'Le Manifeste Dagaz',
    manifestoDescription: 'La philosophie et la motivation derrière le projet Dagaz SvelteKit',
    whyCreated: "Pourquoi J'ai Créé Dagaz",
    corePrinciples: 'Principes Fondamentaux',
    miozuBundle: 'Le Bundle Miozu',
    lookingForward: "Perspectives d'Avenir",
    minimalDependencies: 'Dépendances Minimales',
    functionalApproach: 'Approche Fonctionnelle',
    modularArchitecture: 'Architecture Modulaire',
    nativeFirst: 'Natif en Premier',

    // Home page
    whyChooseDagaz: 'Pourquoi Choisir Dagaz ?',
    gettingStartedSimple: 'Commencer est Simple',
    readyToGoMinute: "Prêt à fonctionner en moins d'une minute. Aucune configuration nécessaire.",
    cloneRepository: 'Cloner le Dépôt',
    startBuildingToday: "Commencez à Construire Votre Projet Aujourd'hui",
    joinCommunity:
      'Rejoignez la communauté croissante de développeurs utilisant Dagaz pour leurs projets.',
    viewOnGitHub: 'Voir sur GitHub',
    readDocumentation: 'Lire la Documentation',
    homePageTitle: 'Dagaz - Starter SvelteKit Minimal pour Landing Pages',
    homePageDescription:
      "Un starter SvelteKit moderne et minimal avec seulement 2 dépendances. Parfait pour les landing pages d'entreprise et les sites axés sur le contenu.",

    // Blog related translations
    tableOfContents: 'Table des Matières',
    share: 'Partager',
    copied: 'Copié !',
    copyLink: 'Copier le Lien',
    previous: 'Précédent',
    next: 'Suivant',
    continueReading: 'Continuer la Lecture',
    topics: 'Sujets',
    subscribeNewsletter: 'Abonnez-vous à notre newsletter',
    newsletterDesc: 'Recevez les derniers articles directement dans votre boîte mail',
    newsletterPlaceholder: 'Votre adresse email',
    subscribe: "S'abonner",
    newsletterDisclaimer: 'Nous respectons votre vie privée. Désabonnez-vous à tout moment.',
    backToTop: 'Retour en haut'
  },
  ua: {
    close: 'Закрити',
    blog: 'Блог',
    github: 'GitHub',
    codeberg: 'Codeberg',
    builtWith: 'Створено з Dagaz',
    allRightsReserved: 'Всі права захищені',
    viewBlog: 'Переглянути Блог',
    selectLanguage: 'Вибрати мову',
    mainSubtitle: 'Сучасний безсерверний блог створений з SvelteKit і Cloudflare',
    keyFeatures: 'Ключові Особливості',
    builtWithModernTech: 'Створено з Сучасними Технологіями',
    blogComingSoon: 'Блог Скоро Буде',
    noPostsFound: 'Публікацій не знайдено.',
    checkBackLater: 'Перевірте пізніше для оновлень.',
    refresh: 'Оновити',
    readArticle: 'Читати Статтю',
    articles: 'Статті',
    blogDescription: 'Огляди та навчальні матеріали з сучасної веб-розробки',
    loadingArticles: 'Завантаження статей...',
    categories: 'Категорії',
    tags: 'Теги',
    resetFilters: 'Скинути Фільтри',
    noMatchingPosts: 'Жодна публікація не відповідає вашим критеріям фільтра.',
    showAllPosts: 'Показати Всі Публікації',
    loadingPost: 'Завантаження публікації...',
    minRead: 'хв читання',
    backToPosts: 'Назад до публікацій',
    postNotFound: 'Публікацію Не Знайдено',
    postNotFoundDesc: 'На жаль, публікацію, яку ви шукаєте, не вдалося завантажити.',
    returnToBlog: 'Повернутися до блогу',
    home: 'Головна',
    copyright: '© {year}',
    pageTitle: 'Dagaz - Сучасний Безсерверний Стартер Блогу',

    // Feature names
    trulyServerless: 'Повністю Безсерверний',
    markdownBlog: 'Блог на Markdown',
    darkLightTheme: 'Темна/Світла Тема',
    localization: 'Локалізація',

    // Feature descriptions
    trulyServerlessDesc: 'Нульове управління сервером з глобальною доставкою CDN',
    markdownBlogDesc: 'Пишіть контент у простому форматі markdown',
    darkLightThemeDesc: 'Вбудоване перемикання теми з визначенням системи',
    localizationDesc: 'Вбудована підтримка багатомовності',

    // Tech stack
    svelteKit: 'SvelteKit 2.x',
    tailwind: 'Tailwind 4',
    cloudflare: 'Cloudflare',
    pnpm: 'PNPM',

    // Theme
    switchToLightMode: 'Перейти на світлу тему',
    switchToDarkMode: 'Перейти на темну тему',

    // New translations for Contact page
    contact: 'Контакт',
    contactSubtitle: 'Давайте почнемо розмову про ваш проект',
    contactName: "Ім'я",
    contactEmail: 'Email',
    contactMessage: 'Повідомлення',
    contactNamePlaceholder: "Ваше ім'я",
    contactEmailPlaceholder: 'ваш.email@приклад.com',
    contactMessagePlaceholder: 'Розкажіть мені про ваш проект...',
    contactSending: 'Відправлення...',
    contactSend: 'Надіслати повідомлення',
    contactSendAnother: 'Надіслати інше повідомлення',
    contactSuccess: 'Повідомлення надіслано',
    contactOtherWays: "Інші способи зв'язку",
    contactNameError: "Будь ласка, введіть ваше ім'я (щонайменше 2 символи)",
    contactEmailError: 'Будь ласка, введіть дійсну адресу електронної пошти',
    contactMessageError: 'Будь ласка, введіть повідомлення (щонайменше 10 символів)',

    // New translations for Manifesto page
    manifesto: 'Маніфест',
    manifestoTitle: 'Маніфест Dagaz',
    whyCreated: 'Чому я створив Dagaz',
    corePrinciples: 'Основні принципи',
    miozuBundle: 'Набір Miozu',
    lookingForward: 'Погляд у майбутнє',
    minimalDependencies: 'Мінімальні залежності',
    functionalApproach: 'Функціональний підхід',
    modularArchitecture: 'Модульна архітектура',
    nativeFirst: 'Нативність перш за все',

    // Blog related translations
    tableOfContents: 'Зміст',
    share: 'Поділитися',
    copied: 'Скопійовано!',
    copyLink: 'Копіювати посилання',
    previous: 'Попередня',
    next: 'Наступна',
    continueReading: 'Продовжити читання',
    topics: 'Теми',
    subscribeNewsletter: 'Підпишіться на нашу розсилку',
    newsletterDesc: 'Отримуйте останні публікації прямо у вашій поштовій скриньці',
    newsletterPlaceholder: 'Ваша електронна адреса',
    subscribe: 'Підписатися',
    newsletterDisclaimer: 'Ми поважаємо вашу приватність. Відписатися можна в будь-який час.',
    backToTop: 'Нагору'
  },
  zh: {
    close: '关闭',
    blog: '博客',
    github: 'GitHub',
    codeberg: 'Codeberg',
    builtWith: '由Dagaz构建',
    allRightsReserved: '版权所有',
    viewBlog: '查看博客',
    selectLanguage: '选择语言',
    mainSubtitle: '一个使用SvelteKit和Cloudflare构建的现代无服务器博客',
    keyFeatures: '主要功能',
    builtWithModernTech: '使用现代技术构建',
    blogComingSoon: '博客即将推出',
    noPostsFound: '没有找到博客文章。',
    checkBackLater: '稍后再来查看新内容和更新。',
    refresh: '刷新',
    readArticle: '阅读文章',
    articles: '文章',
    blogDescription: '关于现代网络开发的见解和教程',
    loadingArticles: '加载文章中...',
    categories: '分类',
    tags: '标签',
    resetFilters: '重置筛选器',
    noMatchingPosts: '没有符合当前筛选条件的文章。',
    showAllPosts: '显示所有文章',
    loadingPost: '加载文章中...',
    minRead: '分钟阅读',
    backToPosts: '返回到文章',
    postNotFound: '未找到文章',
    postNotFoundDesc: '抱歉，您查找的文章无法加载。',
    returnToBlog: '返回到博客',
    home: '首页',
    copyright: '© {year}',
    pageTitle: 'Dagaz - 现代无服务器博客启动器',

    // Feature names
    trulyServerless: '真正的无服务器',
    markdownBlog: 'Markdown博客',
    darkLightTheme: '深色/浅色主题',
    localization: '本地化',

    // Feature descriptions
    trulyServerlessDesc: '零服务器管理，全球CDN分发',
    markdownBlogDesc: '使用易于使用的markdown格式编写内容',
    darkLightThemeDesc: '内置主题切换与系统检测',
    localizationDesc: '内置多语言支持',

    // Tech stack
    svelteKit: 'SvelteKit 2.x',
    tailwind: 'Tailwind 4',
    cloudflare: 'Cloudflare',
    pnpm: 'PNPM',

    // Theme
    switchToLightMode: '切换到浅色模式',
    switchToDarkMode: '切换到深色模式',

    // New translations for Contact page
    contact: '联系我们',
    contactSubtitle: '让我们谈谈您的项目',
    contactName: '姓名',
    contactEmail: '邮箱',
    contactMessage: '留言',
    contactNamePlaceholder: '您的姓名',
    contactEmailPlaceholder: '您的邮箱@示例.com',
    contactMessagePlaceholder: '告诉我关于您的项目...',
    contactSending: '发送中...',
    contactSend: '发送消息',
    contactSendAnother: '发送另一条消息',
    contactSuccess: '消息已发送',
    contactOtherWays: '其他联系方式',
    contactNameError: '请输入您的姓名（至少2个字符）',
    contactEmailError: '请输入有效的电子邮件地址',
    contactMessageError: '请输入消息（至少10个字符）',

    // New translations for Manifesto page
    manifesto: '宣言',
    manifestoTitle: 'Dagaz宣言',
    whyCreated: '为什么我创建了Dagaz',
    corePrinciples: '核心原则',
    miozuBundle: 'Miozu套件',
    lookingForward: '展望未来',
    minimalDependencies: '最小依赖',
    functionalApproach: '函数式方法',
    modularArchitecture: '模块化架构',
    nativeFirst: '原生优先',

    // Blog related translations
    tableOfContents: '目录',
    share: '分享',
    copied: '已复制！',
    copyLink: '复制链接',
    previous: '上一篇',
    next: '下一篇',
    continueReading: '继续阅读',
    topics: '主题',
    subscribeNewsletter: '订阅我们的通讯',
    newsletterDesc: '获取直接发送到您收件箱的最新文章',
    newsletterPlaceholder: '您的电子邮件地址',
    subscribe: '订阅',
    newsletterDisclaimer: '我们尊重您的隐私。随时可以取消订阅。',
    backToTop: '返回顶部'
  }
};
